/**
 * Use this directive to display a user with image and company
 *
 * @params {user=} user object (use UserBaseDTO)
 * @params {headerTitle=} label which will be placed above this data (use it for labels like buyer, supplier, ...)

 * @usage
 * <ix-user-panel user="data.user" header-title="{{::trns.buyer}}"></ix-user-panel>
 *
 */
angular.module('impactx.user').directive('ixUserPanel', ['$context', function($context) {
    return {
        restrict: 'E',
        controller: 'UserPanelCtrl',
        controllerAs: 'userPanelCtrl',
        templateUrl: 'shared/user/templates/userpanel.tmpl.html',
        scope: true,
        bindToController: {
            user: "=",
            headerTitle: "@",
            clazz: "=?",
            ignoreId: "=?",
            buttonFunction: "=",
            buttonTranslation: "@"
        },
        link: function (scope) {
            scope.contextUserId = $context.userId.value;
        }
    }
}]);